import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_4JY2zE5skUWg: {
	id: 'prd_4JY2z2DEV2E5skUWg'
	ident: 'prd_4JY2zE5skUWg'
	sku: 'simple_workbook_bundle_26_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_Eeumf2DEV2rqOYRoD'
		amount: 64
		amount_usd: 26
		currency: 'USD'
		amount_with_discount: 26
		discount: 38
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_4JY2zE5skUWg, OneTimeProduct>
const prd_4JY2zE5skUWg = { ident: 'prd_4JY2zE5skUWg' } as typeof _prd_4JY2zE5skUWg

export default prd_4JY2zE5skUWg
